import { Node, type Extensions } from '@tiptap/core'

/** Preserve simple imported lesson tables while allowing their cell text to be edited. */
export function getCourseTableExtensions(): Extensions {
    return [
        Node.create({
            name: 'courseTable',
            group: 'block',
            content: 'courseTableRow+',
            isolating: true,
            parseHTML: () => [{ tag: 'table' }],
            renderHTML: ({ HTMLAttributes }) => ['table', HTMLAttributes, ['tbody', 0]]
        }),
        Node.create({
            name: 'courseTableRow',
            content: '(courseTableCell | courseTableHeader)+',
            parseHTML: () => [{ tag: 'tr' }],
            renderHTML: ({ HTMLAttributes }) => ['tr', HTMLAttributes, 0]
        }),
        Node.create({
            name: 'courseTableHeader',
            content: 'block+',
            isolating: true,
            parseHTML: () => [{ tag: 'th' }],
            renderHTML: ({ HTMLAttributes }) => ['th', HTMLAttributes, 0]
        }),
        Node.create({
            name: 'courseTableCell',
            content: 'block+',
            isolating: true,
            parseHTML: () => [{ tag: 'td' }],
            renderHTML: ({ HTMLAttributes }) => ['td', HTMLAttributes, 0]
        })
    ]
}
